<app-banner [heading]="image[0].caption" [detail]="'Tagore Global School - Kurukshetra.'"></app-banner>


<section id="events">
  <div class="container">

    <div class="row">
      <div class="col-md-4 " *ngFor="let img of image;">
              <div class="card">
                <div class="card-img">
                  <img [src]="img.imgUrl" [alt]="img.caption" class="img-fluid mx-auto">
                </div>
              
              </div>
        </div>

</div>

  </div>
</section>
